import fetch from '../fetch'

export default ({
  id,
  formData,
  name,
  type,
  part,
  // orderNum = 1,
  itemOrderNum = 1,
}: {
  id: string
  formData: any
  name: string
  type: string
  part: string
  //orderNum: number
  itemOrderNum: number
}) => {
  let params = {
    part: part,
    type: type,
    //orderNum: orderNum,
    fileName: name,
    itemOrderNum: itemOrderNum,
  }
  const token = localStorage.getItem('token')
  return fetch({
    method: 'POST',
    path: `api/v1/case-report/${id}/attachment`,
    headers: {
      Authorization: token && `Bearer ${token}`,
    },
    params: params,
    data: formData,
  })
}
